/**复核算税 */
import { $http, buildHeaders } from "./index";

//获取列表
export const recalctaxemployee_list = (params) => {
  return $http.get("/admin/ReCalcTaxEmployee/index", { params });
};

//获取详情列表
export const recalctaxemployee_detail = (id) => {
  return $http.get("/admin/ReCalcTaxEmployee/detail", { params: { id } });
};

//删除
export const recalctaxemployee_del = (id) => {
  return $http.post(
    "/admin/ReCalcTaxEmployee/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//算税
export const recalctaxemployee_submit = (id) => {
  return $http.post(
    "/admin/ReCalcTaxEmployee/submit",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};
